import { startOfYear, subMonths } from "date-fns";

const DEFAULT_LAST_TOLERATED_MONTH_INDEX = 1;
const ROLLOVER_MONTHS = 2;

/**
 * Plus bas seuil de date accepté pour une opération imputable à un exercice fiscal
 * (cours saisi, facture émise…). Pennylane rejette les factures rattachées à un
 * exercice clôturé : on bloque donc les dates antérieures à l'année courante,
 * sauf pendant la période de rollover (jusqu'en `lastToleratedMonthIndex` inclus),
 * où l'on tolère les `ROLLOVER_MONTHS` derniers mois pour absorber les retards
 * de saisie de l'exercice précédent.
 */
export const getMinFiscalPeriodDate = (now: Date, lastToleratedMonthIndex = DEFAULT_LAST_TOLERATED_MONTH_INDEX): Date => {
  const month = now.getMonth();
  return month <= lastToleratedMonthIndex ? subMonths(now, ROLLOVER_MONTHS) : startOfYear(now);
};
